const MILLION = 1000000;

export const calculateYAxisScale = (values: unknown[]) => {
    const amounts = values
        .filter((value): value is number => typeof value === 'number' && Number.isFinite(value))
        .map((value) => value / MILLION);
    const minValue = Math.min(0, ...amounts);
    const maxValue = Math.max(0, ...amounts);

    if (minValue === 0 && maxValue === 0) {
        return { min: 0, max: 5 * MILLION, stepSize: MILLION };
    }

    const paddedMin = minValue * 1.1;
    const paddedMax = maxValue * 1.1;
    const targetStep = Math.max((paddedMax - paddedMin) / 6, 1);
    const magnitude = Math.pow(10, Math.floor(Math.log10(targetStep)));
    // Choose the round interval that gets closest to six divisions.
    // A minimum of one million keeps the displayed ticks integer-valued.
    const candidates = [1, 2, 5, 10].map((factor) => factor * magnitude);
    const intervalCount = (step: number) =>
        Math.ceil(paddedMax / step) - Math.floor(paddedMin / step);
    const step = candidates.reduce((best, candidate) =>
        Math.abs(intervalCount(candidate) - 6) < Math.abs(intervalCount(best) - 6)
            ? candidate : best
    );

    return {
        min: Math.floor(paddedMin / step) * step * MILLION,
        max: Math.ceil(paddedMax / step) * step * MILLION,
        stepSize: step * MILLION,
    };
};
